import type { ComponentDefinition } from '@/types/reports';

export const TIKTOK_TRENDS_DEFINITION: ComponentDefinition = {
  type: 'tiktok-trends',
  name: 'Tiktok Trends',
  description: 'Seção com Hashtags, Creators e Marcas (colapsáveis)',
  fields: [
    { key: 'hashtagCategories', label: 'Hashtags', type: 'hashtag-categories' },
    { key: 'creators', label: 'Creators', type: 'creator-entries' },
    { key: 'brands', label: 'Marcas', type: 'brand-entries' },
  ],
};
